import { Box, Typography, ImageList, ImageListItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import NavBar from "../NavBar/NavBar";
import heroImg from "../images/pexels-pixabay-220836.jpg";

// logos imports (unchanged)
import logo1 from "../images/partners/2.jpeg";
import logo2 from "../images/partners/4.jpeg";
import logo3 from "../images/partners/6.png";
import logo4 from "../images/partners/10.jpeg";
import logo5 from "../images/partners/12.png";
import logo6 from "../images/partners/13.jpeg";
import logo7 from "../images/partners/14.jpeg";
import logo8 from "../images/partners/15.jpeg";
import logo9 from "../images/partners/16.jpeg";
import logo10 from "../images/partners/18.jpeg";
import logo11 from "../images/partners/22.jpeg";
import logo12 from "../images/partners/1200px-O2-Logo.png";
import logo13 from "../images/partners/2000px-YouTube_Logo_2017.svg_.png";
import logo14 from "../images/partners/alshaqab_logo_bordeaux_2015-500px-410x227-1.png";
import logo15 from "../images/partners/Amplifon-logo-2016.png";
import logo16 from "../images/partners/arena.png";
import logo17 from "../images/partners/BBC-logo.png";
import logo18 from "../images/partners/bentley.png";
import logo19 from "../images/partners/cartier_logo_2.png";
import logo20 from "../images/partners/channel-4-logo.png";
import logo21 from "../images/partners/Channel-5-Logo.png";
import logo22 from "../images/partners/Channel-7-Aus.png";
import logo23 from "../images/partners/Coutts-logo.jpeg";
import logo24 from "../images/partners/creed-logo.png";
import logo25 from "../images/partners/DEBRA_logo.png";
import logo26 from "../images/partners/Eurosport_logo.png";
import logo27 from "../images/partners/highclere-brand-colour.png";
import logo28 from "../images/partners/investec_owler_20160226_174820_original.png";
import logo29 from "../images/partners/ITV-Logo-1.png";
import logo30 from "../images/partners/le-chameau-logo.png";
import logo31 from "../images/partners/lloyds-bank.png";
import logo32 from "../images/partners/logo-BOC-Blackout-Concept-400x188-3.jpeg";
import logo33 from "../images/partners/logo-marriott-3.png";
import logo34 from "../images/partners/longines-watches-logo.png";
import logo35 from "../images/partners/moving-comfort.png";
import logo36 from "../images/partners/natwest-bank-logo-1.png";
import logo37 from "../images/partners/newmarket-logo.png";
import logo38 from "../images/partners/orchid.png";
import logo39 from "../images/partners/PandO-Cruises_logo400px.jpeg";
import logo40 from "../images/partners/pcf-logo-700.png";
import logo41 from "../images/partners/pied-piper-charity-event.png";
import logo42 from "../images/partners/raging_bull.png";
import logo43 from "../images/partners/royal-ascot-logo-2017.png";
import logo44 from "../images/partners/Royal-Padel-logo-e1521056223947.png";
import logo45 from "../images/partners/Simon-LMO-logo-Red.png";
import logo46 from "../images/partners/SKY_SPORTS_WITHOUT_KEYLINE_RGB_crop.png";
import logo47 from "../images/partners/Sky-logo-2016.png";
import logo48 from "../images/partners/SunseekerLogo-e1464098947787.png";
import logo49 from "../images/partners/The-Sun.jpeg";
import logo50 from "../images/partners/thorntons-logo.png";
import logo51 from "../images/partners/thumb-1920-493353.jpg";
import logo52 from "../images/partners/towcester-logo.png";
import logo53 from "../images/partners/virgin-atlantic-logo-png-virgin-atlantic-airways-2272.png";
import logo54 from "../images/partners/wooden-spoon.png";
import logo55 from "../images/partners/ysl-final.png";
import SEO from "../app/SEO";

const logos = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
  logo20,
  logo21,
  logo22,
  logo23,
  logo24,
  logo25,
  logo26,
  logo27,
  logo28,
  logo29,
  logo30,
  logo31,
  logo32,
  logo33,
  logo34,
  logo35,
  logo36,
  logo37,
  logo38,
  logo39,
  logo40,
  logo41,
  logo42,
  logo43,
  logo44,
  logo45,
  logo46,
  logo47,
  logo48,
  logo49,
  logo50,
  logo51,
  logo52,
  logo53,
  logo54,
  logo55,
];

export default function PartnersPage() {
  const { t } = useTranslation("partners");
  const [lightNav, setLightNav] = useState(true);
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setLightNav(entry.isIntersecting);
      },
      { threshold: 0.05 }
    );

    if (heroRef.current) observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F6F5F3", minHeight: "100vh" }}>
      <SEO
        title="Partners| Talent Representation, Bookings & Fan Experiences"
        description=""
        canonical={``}
        ogImage={""}
      />
      <NavBar mode={lightNav ? "light" : "dark"} />

      {/* HERO */}
      <Box
        ref={heroRef}
        sx={{
          position: "relative",
          height: { xs: "45vh", md: "60vh" },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${heroImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.6)",
          }}
        />
      </Box>

      {/* TITLE */}
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          px: { xs: 3, md: 8 },
          py: { xs: 6, md: 8 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "1.6rem", md: "2.4rem" },
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#111",
          }}
        >
          {t("title")}
        </Typography>
      </Box>

      {/* LOGOS */}
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          px: { xs: 2, md: 6 },
          pb: { xs: 8, md: 12 },
        }}
      >
        <ImageList
          gap={40}
          sx={{
            gridTemplateColumns: {
              xs: "repeat(3, 1fr)",
              sm: "repeat(4, 1fr)",
              md: "repeat(5, 1fr)",
            },
          }}
        >
          {logos.map((logo, index) => (
            <ImageListItem
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                filter: "grayscale(100%)",
                opacity: 0.75,
                transition: "all 0.3s ease",
                "&:hover": {
                  filter: "grayscale(0%)",
                  opacity: 1,
                  transform: "scale(1.03)",
                },
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Partner logo"
                loading="lazy"
                sx={{
                  maxWidth: "100%",
                  maxHeight: 80,
                  objectFit: "contain",
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
    </Box>
  );
}
